import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

declare global {
  interface PromiseConstructor {
    try?<T>(fn: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]): Promise<T>;
  }
}

// pdfjs-dist (used for PhonePe/GPay statement import and PDF-to-Markdown) calls the ES2025
// Promise.try internally. Chrome/Firefox only shipped it in late 2024 and Safari in early 2025,
// so on an older browser this throws "Promise.try is not a function" deep inside pdf.js and the
// whole PDF load silently fails - including the password-prompt path, since that failure looks
// like any other crash, not a PasswordException.
if (typeof Promise.try !== 'function') {
  Promise.try = function <T>(fn: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]): Promise<T> {
    return new Promise((resolve) => resolve(fn(...args)));
  };
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
